import Categories from "./categories";
export default function CategoriesMain() {

    return (
        <section id="catagories">
            <ul>
                <Categories alt="Mobiles" id="Mobiles" title='Mobile' image='https://rukminim1.flixcart.com/fk-p-flap/144/144/image/64f1cc66052c66ef.png?q=100'></Categories>
                <Categories alt="Electronics" id="Electronics" title={'Electronic'} image='https://rukminim1.flixcart.com/fk-p-flap/144/144/image/1fd83847b32a09d1.png?q=100'></Categories>
                <Categories alt="Fashion" id="Fashion" title={'Fashion'} image='https://rukminim1.flixcart.com/fk-p-flap/144/144/image/6dbed7ba5417672f.jpg?q=100'></Categories>
                <Categories alt="Beauty" id="beauty" title={'Beauty'} image='https://rukminim1.flixcart.com/fk-p-flap/144/144/image/c444de48eb75d450.png?q=100'></Categories>
                <Categories alt="Furniture" id="Furniture" title={'Furniture'} image='https://rukminim1.flixcart.com/fk-p-flap/144/144/image/26e11f4698473e49.png?q=100'></Categories>
                <Categories alt="Home & Kitchen" id="Home+Kitchen" title={'Home'} image='https://rukminim1.flixcart.com/fk-p-flap/144/144/image/f9c7aaa5f5455ae7.png?q=100'></Categories>
            </ul>
        </section>
    );
}